import axios from 'core/axiosInstance';
import axiosNoRedirect from 'core/axiosInstanceNoRedirect';

const rootService = serviceStructure =>
    Object.entries(serviceStructure).reduce((acc, [key, [method, urlTemplate, configuration]]) => {
        const {
            headers,
            mockError,
            mockResponse,
            noRedirect
        } = configuration ?? {};
        const serviceFunction = async (urlParams, payload = {}, serviceConfig = {}) => {
            if (mockResponse) return ({ data: mockResponse });
            if (mockError) throw new Error(mockError);
            const { replaceHeaders } = serviceConfig;
            const url = Object.keys(urlParams ?? {}).reduce(
                (accUrl, param) => accUrl.replace(`:${ param }`, urlParams[param]),
                urlTemplate
            );
            const { data } = await (!noRedirect ? axios : axiosNoRedirect)({
                ...(replaceHeaders ? { headers: replaceHeaders } : (headers && { headers })),
                method,
                url,
                ...(method === 'GET' ? { params: payload } : { data: payload })
            });
            return data;
        };
        return {
            ...acc,
            [key]: serviceFunction
        };
    }, {});

export default rootService;
